export const LOADING = "FP_LOADING";
export const ERROR = "FP_ERROR";
export const SUCCESS = "FP_SUCCESS";
